@if(isEditable()) {


<div mwlResizable [enableGhostResize]="true" [resizeSnapGrid]="{ left: snapX, right: snapX, top: snapY, bottom: snapY }"
  (resizeEnd)="onResizeEnd($event)" [style.background-color]="data().backgroundColor ?? '#ffffff'"
  [style.color]="data().color ?? 'inherit'" class="container shadow-1 drop-column ">
  <app-widget-header [data]="data()" [(showOptions)]="showOptions" [isEditable]="isEditable()" />
  <div mwlResizeHandle [resizeEdges]="{ bottom: true, right: true }" class="resize-handle"></div>
  <ng-container [ngComponentOutlet]="data().content" [ngComponentOutletInjector]="dataInjector" />

  @if (showOptions()) {
  <app-widget-options [data]="data()" [(showOptions)]="showOptions"></app-widget-options>
  }
</div>
} @else {
<div class="block rounded-2xl" [style.background-color]="data().backgroundColor ?? '#ffffff'"
  [style.color]="data().color ?? 'inherit'" class="container shadow-1 ">
  <!-- <app-widget-header [data]="data()" [(showOptions)]="showOptions" [isEditable]="isEditable()" />-->

  <ng-container [ngComponentOutlet]="data().content" [ngComponentOutletInjector]="dataInjector" />

  @if (showOptions()) {
  <app-widget-options [data]="data()" [(showOptions)]="showOptions"></app-widget-options>
  }
</div>

}